import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { useServerWrite } from 'dg-web-shared/lib/hooks/ServerStateHooks.ts';
import {
    CloudConnectorPeripheryEventType,
    CloudConnectorPeripheryType,
} from 'dg-web-shared/model/CloudConnector.ts';
import Alert from '@mui/material/Alert';
import { OperatorZoneBarrierGatePeriphery } from './CloudConnectorPeripheriesOverview.tsx';

export enum CloudConnectorCommandType {
    BARRIER_UP_ONCE = 'BARRIER_UP_ONCE',
    BARRIER_PERMANENTLY_OPEN = 'BARRIER_PERMANENTLY_OPEN',
    FORCE_OUT_OF_ORDER = 'FORCE_OUT_OF_ORDER',
}

export interface ZoneBarrierGatePeripheryCommand {
    operatorId: number;
    zoneId: number;
    peripheryType: CloudConnectorPeripheryType;
    onPremiseId: number;
    commandType: CloudConnectorCommandType;
    secondaryGate: boolean | null;
    permanentlyOpen: boolean | null;
    forceOutOfOrder: boolean | null;
    zoneBarrierGateEntryWithoutExitId: number | null;
}

export function usePeripheryCommand() {
    return useServerWrite<ZoneBarrierGatePeripheryCommand, null>(
        ({ operatorId, zoneId, peripheryType, onPremiseId }) => ({
            url: `/ui-api/operator-account/${operatorId}/zone-barrier-gate/${zoneId}/periphery/${peripheryType}/${onPremiseId}/command`,
        }),
    );
}

export function isPeripheryDisconnected(
    peripheryConfig: OperatorZoneBarrierGatePeriphery,
): boolean {
    return peripheryConfig.events.some(
        event =>
            event.eventType === CloudConnectorPeripheryEventType.DISCONNECTED,
    );
}

export function RequestErrorAlert({ open }: { open: boolean }) {
    if (open) {
        return (
            <Alert severity="error" sx={{ margin: '0 0 24px 0' }}>
                <Localized
                    de="Die Aktion konnte nicht ausgeführt werden."
                    fr="L'action n'a pas pu être réalisée."
                    it="Non è stato possibile eseguire l'azione."
                    en="The action could not be carried out."
                />
            </Alert>
        );
    }
    return null;
}
